import { useQuery } from 'react-query'
import { axios } from '../../../lib'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from '../../../services/api/types'

type Data = PaginatedParams & {
  unityId?: string
  paymentTermId?: string
}

const loadOrderPaymentMethods = (data: Data): PaginatedResponse<any> => {
  const { page = 1, limit = 100 } = data

  return axios.get(`/orders/payment-methods`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderPaymentMethods(query: Data) {
  return useQuery(
    ['orderPaymentMethods', query],
    () => loadOrderPaymentMethods(query),
    {
      keepPreviousData: true,
      enabled: !!query.unityId && !!query.paymentTermId,
      onError: () =>
        toast.error('Não foi possível carregar os tipos de pagamento!', {
          toastId: 'orderPaymentMethods'
        })
    }
  )
}
